import React from 'react';

export const NoData = ({
  ariaLabel,
  testId,
  className = '',
}: {
  ariaLabel?: string;
  testId?: string;
  className?: string;
}) => {
  const dataTestId = testId ?? 'no-data';

  return (
    <span data-testid={dataTestId} aria-label={ariaLabel ?? 'Not applicable or available'} className={className}>
      -
    </span>
  );
};
